<template>
  <div>
    <v-list class="pt-0" two-line>
      <div class="fixed-header ml-2 mt-3">
        <v-row class="px-5 mt-2">
          <v-col cols="10">
            <h2 v-if="userAction === 'create' || userAction === 'duplicate'">
              <span class="font-weight-medium-custom">Add User</span>
            </h2>
            <h2 v-if="userAction === 'edit'">
              <span class="font-weight-medium-custom"> Edit User</span>
            </h2>
          </v-col>
          <v-col cols="2" class="d-flex justify-end pr-0">
            <v-btn
              class="text-right"
              icon
              @click.stop="closeDrawer()"
              id="close-create-user-drawer-btn"
              v-track="'close-create-user-drawer-btn'"
            >
              <v-icon medium> mdi-close </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>
      <div class="ml-2 mt-4">
        <v-row class="px-5">
          <v-col cols="12">
            <v-form
              v-model="validAddUserEmail"
              ref="validAddUserEmail"
              lazy-validation
            >
              <v-text-field
                id="add-new-user-email"
                ref="addNewUserEmail"
                v-model.trim="addNewUserEmail"
                label="Email *"
                outlined
                required
                persistent-hint
                :rules="emailRules"
                :disabled="disableUserEmail"
                @input="enableSaveAddUser = true"
                validate-on-blur
              />
            </v-form>
          </v-col>
        </v-row>
        <v-row class="px-5">
          <v-col cols="12" class="mt-0 pt-0 body-1">
            <h2 class="body-1">
             <span class="font-weight-medium-custom secondary--font">Access & Permissions</span> 
            </h2>
          </v-col>
        </v-row>
        <v-row class="wrapper-row">
          <v-col cols="12" md="8">
            <!---- different tabs section ----->
            <v-tabs
              color="#03b6fc"
              :mobile-breakpoint="960"
              show-arrows
              class="ml-8"
              v-model="activeTab"
            >
              <v-tab
                v-for="item in tabList"
                :key="item.id"
                :id="item.id"
                :to="item.route"
                :value="item.value"
                class="body-2"
                v-show="item.visible"
              >
                {{ item.name }}</v-tab
              >
            </v-tabs>
          </v-col>
        </v-row>
        <v-divider class="mx-8" />
        <v-tabs-items v-model="activeTab">
          <v-tab-item v-for="item in tabList" :key="item.id">
            <v-card flat>
              <v-card-text v-if="item.name == 'General'" class="body-1">
                <v-row v-if="userAction === 'edit'" class="px-5">
                  <v-col cols="10">
                    <span
                      :class="
                        primaryContact
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                    >
                      Set this contact as primary contact
                    </span>
                    <span>
                      <v-tooltip
                        bottom
                        color="rgba(0, 0, 0, 0.9)"
                        max-width="400px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-icon
                            v-on="on"
                            :class="
                              primaryContact
                                ? 'black--text'
                                : 'grey--text text--darken-1'
                            "
                          >
                            mdi-information-outline
                          </v-icon>
                        </template>
                        <span class="caption"
                          >Make this user the point of contact for
                          communications from Maropost. There can only be one
                          primary contact per account.</span
                        >
                      </v-tooltip>
                    </span>
                  </v-col>
                  <v-col cols="2" class="my-0 py-0 d-flex justify-end">
                    <v-switch
                      id="primary-contact"
                      v-track="'primary-contact'"
                      v-model="primaryContact"
                      color="#03b6fc"
                      class="set-primary-contact py-0"
                      @change="checkHasPrimaryContact()"
                    />
                  </v-col>
                  <v-divider class="mx-3 mb-3" />
                </v-row>
                <v-row class="px-5 wrapper-row">
                  <v-col
                    cols="10"
                    :class="
                      generalRoles.account
                        ? 'black--text'
                        : 'grey--text text--darken-1'
                    "
                  >
                    Accounts and Users
                  </v-col>
                  <v-col class="d-flex justify-end" cols="2">
                    <v-switch
                      id="show-account"
                      v-track="'show-account'"
                      v-model="generalRoles.account"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row mt-0">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group v-model="accountRadio" class="py-0 my-0">
                        <v-radio
                          key="account"
                          value="account"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="account-full-access-radio"
                          v-track="'account-full-access-radio'"
                          :disabled="!generalRoles.account"
                        >
                          <template v-slot:label>
                            <span
                              :class="generalRoles.account ? 'black--text' : ''"
                              >Full Access</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group v-model="accountRadio" class="py-0 my-0">
                        <v-radio
                          key="accounts_read_only"
                          value="accounts_read_only"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="account-read-only-radio"
                          v-track="'account-read-only-radio'"
                          :disabled="!generalRoles.account"
                        >
                          <template v-slot:label>
                            <span
                              :class="generalRoles.account ? 'black--text' : ''"
                              >View Only</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10">
                    <span>
                      <a
                        href="https://www.maropost.com/privacy-policy/"
                        target="_blank"
                        id="add-user-privacy-policy"
                        v-track="'privacy-policy-link'"
                        class="text-decoration-none"
                        >Privacy Policy</a
                      >
                    </span>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-text v-else-if="item.name == 'Marketing'" class="body-1">
                <v-row class="px-5 pb-3 wrapper-row pt-1">
                  <v-col cols="4">
                    <v-btn-toggle
                      v-model="toggle_marketing"
                      mandatory
                      dense
                      class="text--white"
                    >
                      <v-btn
                        :value="true"
                        :color="toggle_marketing ? '#03B6FC' : '#FFFFFF'"
                        :class="toggle_marketing ? 'white--text' : ''"
                        v-track="'marketing-toogle-on'"
                        ><span class="button font-weight-bold">On</span></v-btn
                      >
                      <v-btn
                        :value="false"
                        :color="
                          toggle_marketing ? '#FFFFFF' : 'blue-grey darken-3'
                        "
                        :class="toggle_marketing ? '' : 'white--text'"
                        v-track="'marketing-toogle-off'"
                        ><span class="button font-weight-bold">Off</span></v-btn
                      >
                    </v-btn-toggle>
                  </v-col>
                  <v-col class="d-flex" cols="8">
                    <span
                      v-if="tabList[activeTab].name == 'Marketing'"
                      class="body-1 mt-2"
                      >Provide Marketing Cloud Access</span
                    >
                  </v-col>
                  <v-divider class="mx-2 mt-2" />
                </v-row>
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10">
                    <span
                      :class="
                        roles.campaigns
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                      >Campaigns</span
                    >
                  </v-col>
                  <v-col class="d-flex justify-end" cols="2">
                    <v-switch
                      id="show-campaigns"
                      v-track="'show-campaigns'"
                      v-model="roles.campaigns"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row mt-0">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group v-model="campaignsRadio" class="py-0 my-0">
                        <v-radio
                          key="campaign_full_access"
                          value="campaign_full_access"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="campaign-full-access-radio"
                          v-track="'campaign-full-access-radio'"
                          :disabled="!roles.campaigns"
                        >
                          <template v-slot:label>
                            <span :class="roles.campaigns ? 'black--text' : ''"
                              >Full Access</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group v-model="campaignsRadio" class="py-0 my-0">
                        <v-radio
                          key="campaign_edit_schedule"
                          value="campaign_edit_schedule"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="campaign-edit-schedule-radio"
                          v-track="'campaign-edit-schedule-radio'"
                          :disabled="!roles.campaigns"
                        >
                          <template v-slot:label>
                            <span :class="roles.campaigns ? 'black--text' : ''"
                              >Schedule and Send Only</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group v-model="campaignsRadio" class="py-0 my-0">
                        <v-radio
                          key="campaign_requires_approval"
                          value="campaign_requires_approval"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="campaign-requires-approval-radio"
                          v-track="'campaign-requires-approval-radio'"
                          :disabled="!roles.campaigns"
                        >
                          <template v-slot:label>
                            <span :class="roles.campaigns ? 'black--text' : ''"
                              >Requires Approval to Access</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>

                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col
                    cols="10"
                    :class="
                      roles.contents
                        ? 'black--text'
                        : 'grey--text text--darken-1'
                    "
                  >
                    Content
                  </v-col>
                  <v-col class="d-flex justify-end" cols="2">
                    <v-switch
                      id="show-contents"
                      v-track="'show-contents'"
                      v-model="roles.contents"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row mt-0">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group v-model="contentRadio" class="py-0 my-0">
                        <v-radio
                          key="no"
                          value="no"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="content-normal-user-radio"
                          v-track="'content-normal-user-radio'"
                          :disabled="!roles.contents"
                        >
                          <template v-slot:label>
                            <span :class="roles.contents ? 'black--text' : ''"
                              >Drag And Drop - Normal User</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group v-model="contentRadio" class="py-0 my-0">
                        <v-radio
                          key="yes"
                          value="yes"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="content-admin-user-radio"
                          v-track="'content-admin-user-radio'"
                          :disabled="!roles.contents"
                        >
                          <template v-slot:label>
                            <span :class="roles.contents ? 'black--text' : ''"
                              >Drag And Drop - Admin User</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />

                <v-row class="px-5 wrapper-row">
                  <v-col
                    cols="10"
                    :class="
                      titleReports ? 'black--text' : 'grey--text text--darken-1'
                    "
                  >
                    Reports
                  </v-col>
                  <v-col class="d-flex justify-end" cols="2">
                    <v-switch
                      id="title-reports"
                      v-track="'title-reports'"
                      v-model="titleReports"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row mt-0">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-checkbox
                        class="pa-0 ma-0"
                        color="#03b6fc"
                        id="show-reports"
                        v-track="'show-reports'"
                        v-model="roles.reports"
                        :disabled="!titleReports"
                        @change="reportToggle"
                      >
                        <template v-slot:label>
                          <span :class="titleReports ? 'black--text' : ''">
                            Create</span
                          >
                        </template>
                      </v-checkbox>
                    </span>
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-checkbox
                        class="pa-0 ma-0"
                        v-model="roles.download_reports"
                        color="#03b6fc"
                        id="show-download-reports"
                        v-track="'show-download-reports'"
                        :disabled="!titleReports"
                        @change="reportToggle"
                      >
                        <template v-slot:label>
                          <span :class="titleReports ? 'black--text' : ''"
                            >Download</span
                          >
                        </template>
                      </v-checkbox>
                    </span>
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col
                    cols="10"
                    :class="
                      roles.contacts
                        ? 'black--text'
                        : 'grey--text text--darken-1'
                    "
                  >
                    Audience (Contacts)
                  </v-col>
                  <v-col class="d-flex justify-end" cols="2">
                    <v-switch
                      id="show-contacts"
                      v-track="'show-contacts'"
                      v-model="roles.contacts"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                      @change="toggleContact"
                      :disabled="!toggle_marketing"
                    />
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row mt-0">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-checkbox
                        id="show-download-contacts"
                        v-track="'show-download-contacts'"
                        v-model="roles.download_contacts"
                        color="#03b6fc"
                        class="set-primary-contact my-0 py-0"
                        :disabled="!roles.contacts"
                      >
                        <template v-slot:label>
                          <span :class="roles.contacts ? 'black--text' : ''"
                            >Download contacts list</span
                          >
                        </template>
                      </v-checkbox>
                    </span>
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10" class="mb-0 pb-0">
                    <span
                      :class="
                        roles.surveys
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                    >
                      Survey
                    </span>
                  </v-col>
                  <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                    <v-switch
                      id="show-surveys"
                      v-track="'show-surveys'"
                      v-model="roles.surveys"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10" class="mb-0 pb-0">
                    <span
                      :class="
                        roles.automation
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                    >
                      Automation
                    </span>
                  </v-col>
                  <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                    <v-switch
                      id="show-automation"
                      v-track="'show-automation'"
                      v-model="roles.automation"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10" class="mb-0 pb-0">
                    <span
                      :class="
                        roles.forms
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                    >
                      Forms
                    </span>
                  </v-col>
                  <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                    <v-switch
                      id="show-forms"
                      v-track="'show-forms'"
                      v-model="roles.forms"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10" class="mb-0 pb-0">
                    <span
                      :class="
                        roles.relational_tables
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                    >
                      Relational Tables
                    </span>
                  </v-col>
                  <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                    <v-switch
                      id="show-relational-tables"
                      v-track="'show-relational-tables'"
                      v-model="roles.relational_tables"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10" class="mb-0 pb-0">
                    <span
                      :class="
                        roles.mobile
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                    >
                      Mobile
                    </span>
                  </v-col>
                  <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                    <v-switch
                      id="show-mobile"
                      v-track="'show-mobile'"
                      v-model="roles.mobile"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10" class="mb-0 pb-0">
                    <span
                      :class="
                        roles.push_notifications
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                    >
                      Push Notification
                    </span>
                  </v-col>
                  <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                    <v-switch
                      id="show-push-notifications"
                      v-track="'show-push-notifications'"
                      v-model="roles.push_notifications"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10" class="mb-0 pb-0">
                    <span
                      :class="
                        roles.coupon_codes
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                    >
                      Coupon Codes
                    </span>
                  </v-col>
                  <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                    <v-switch
                      id="show-coupon-codes"
                      v-track="'show-coupon-codes'"
                      v-model="roles.coupon_codes"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10" class="mb-0 pb-0">
                    <span
                      :class="
                        roles.dns_setup
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                    >
                      DNS Setup
                    </span>
                  </v-col>
                  <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                    <v-switch
                      id="show-sending-domains"
                      v-track="'show-sending-domains'"
                      v-model="roles.dns_setup"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10" class="mb-0 pb-0">
                    <span
                      :class="
                        roles.ftp ? 'black--text' : 'grey--text text--darken-1'
                      "
                    >
                      FTP
                    </span>
                  </v-col>
                  <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                    <v-switch
                      id="show-ftp"
                      v-track="'show-ftp'"
                      v-model="roles.ftp"
                      :disabled="!toggle_marketing"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
              </v-card-text>
              <v-card-text v-else-if="item.name == 'Service'" class="body-1">
                <v-row class="px-5 wrapper-row pt-0">
                  <v-col cols="4">
                    <v-btn-toggle
                      v-model="toggle_service"
                      mandatory
                      dense
                      class="text--white"
                    >
                      <v-btn
                        :value="true"
                        :color="toggle_service ? '#03B6FC' : '#FFFFFF'"
                        :class="toggle_service ? 'white--text' : ''"
                        v-track="'service-toogle-on'"
                        ><span class="button font-weight-bold">On</span></v-btn
                      >
                      <v-btn
                        :value="false"
                        :color="
                          toggle_service ? '#FFFFFF' : 'blue-grey darken-3'
                        "
                        :class="toggle_service ? '' : 'white--text'"
                        v-track="'service-toogle-off'"
                        ><span class="button font-weight-bold">Off</span></v-btn
                      >
                    </v-btn-toggle>
                  </v-col>
                  <v-col class="d-flex" cols="8">
                    <span
                      v-if="tabList[activeTab].name == 'Service'"
                      class="body-1 mt-2"
                      >Provide Service Cloud Access</span
                    >
                  </v-col>
                  <v-divider class="mx-2 mt-2 mb-3" />
                </v-row>
                <v-row class="px-5 wrapper-row">
                  <v-col
                    cols="10"
                    :class="
                      serviceContacts
                        ? 'black--text'
                        : 'grey--text text--darken-1'
                         "
                         class="mb-6"
                  >
                    Contacts
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row mt-0">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group
                        v-model="serviceContactRadio"
                        class="py-0 my-0"
                      >
                        <v-radio
                          key="contacts_full_access"
                          value="contacts_full_access"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="contacts-full-access-radio"
                          v-track="'contacts-full-access-radio'"
                          :disabled="!toggle_service"
                        >
                          <template v-slot:label>
                            <span
                              :class="serviceContactRadio ? 'black--text' : ''"
                              >Full Access</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group
                        v-model="serviceContactRadio"
                        class="py-0 my-0"
                      >
                        <v-radio
                          key="contacts_view_only"
                          value="contacts_view_only"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="contacts-read-only-radio"
                          v-track="'contacts-read-only-radio'"
                          :disabled="!toggle_service"
                        >
                          <template v-slot:label>
                            <span
                              :class="serviceContactRadio ? 'black--text' : ''"
                              >View Only</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>
                  <v-divider class="mx-5 mt-2 mb-4" />
                  <v-row class="px-5 wrapper-row">
                  <v-col
                    cols="10"
                    :class="
                      serviceTickets
                        ? 'black--text'
                        : 'grey--text text--darken-1'
                    "
                    class="mb-6"
                  >
                    Tickets
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row mt-0">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group
                        v-model="serviceTicketRadio"
                        class="py-0 my-0"
                      >
                        <v-radio
                          key="tickets_full_access"
                          value="tickets_full_access"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="tickets-full-access-radio"
                          v-track="'tickets-full-access-radio'"
                          :disabled="!toggle_service"
                        >
                          <template v-slot:label>
                            <span :class="serviceTickets ? 'black--text' : ''"
                              >Full Access</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>
                <v-row class="px-5 wrapper-row">
                  <v-col cols="12" class="py-0 my-0">
                    <span>
                      <v-radio-group
                        v-model="serviceTicketRadio"
                        class="py-0 my-0"
                      >
                        <v-radio
                          key="tickets_view_only"
                          value="tickets_view_only"
                          class="pa-0 ma-0"
                          color="#03b6fc"
                          id="tickets-read-only-radio"
                          v-track="'tickets-read-only-radio'"
                          :disabled="!toggle_service"
                        >
                          <template v-slot:label>
                            <span :class="serviceTickets ? 'black--text' : ''"
                              >View Only</span
                            >
                          </template>
                        </v-radio>
                      </v-radio-group>
                    </span>
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
                <v-row class="px-5 wrapper-row">
                  <v-col cols="10" class="mb-0 pb-0">
                    <span
                      :class="
                        serviceRoles.support_email
                          ? 'black--text'
                          : 'grey--text text--darken-1'
                      "
                    >
                      Support Email
                    </span>
                  </v-col>
                  <v-col cols="2" class="mb-0 pb-0 d-flex justify-end">
                    <v-switch
                      id="show-support-email"
                      v-track="'show-support-email'"
                      v-model="serviceRoles.support_email"
                      :disabled="!toggle_service"
                      color="#03b6fc"
                      class="set-primary-contact my-0 py-0"
                    />
                  </v-col>
                </v-row>
                <v-divider class="mx-5 mt-2 mb-4" />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
        <v-row class="px-5 py-4 secondary--font">
          <v-btn
            class="text-right mx-7 font-weight-bold"
            outlined
            @click.stop="closeDrawer()"
            id="close-create-user-drawer-btn"
            v-track="'close-create-user-drawer-btn'"
          >
            Cancel
          </v-btn>
          <v-btn
            :loading="loading"
            @click.stop="saveUserInfo()"
            class="font-weight-bold"
            id="save-create-user-drawer-btn"
            v-track="'save-create-user-drawer-btn'"
            :dark="(enableSaveAddUser || userAction !== 'create') && hasPermissionSelected"
            :disabled="!enableSaveAddUser && userAction === 'create' || !hasPermissionSelected"
          >
            SAVE
          </v-btn>
        </v-row>
      </div>
    </v-list>
    <v-dialog
      v-model="confirmSetPrimaryContactModal"
      max-width="700"
      @click:outside="
        confirmSetPrimaryContactModal = false;
        primaryContact = !primaryContact;
      "
    >
      <v-card class="px-5">
        <v-card-title class="headline"> Confirm Request </v-card-title>
        <v-card-text class="mt-1" style="font-size: 16px">
          A primary contact already exists for this account. Do you wish to make
          this person the new primary contact?
        </v-card-text>
        <v-card-actions class="mb-1">
          <v-spacer />
          <v-btn
            text
            @click="
              confirmSetPrimaryContactModal = false;
              primaryContact = !primaryContact;
            "
            id="primary-contact-modal-cancel-btn"
            v-track="'primary-contact-modal-cancel-btn'"
          >
            CANCEL
          </v-btn>
          <v-btn
            text
            :loading="loading"
            @click.stop="setPrimaryContact()"
            id="primary-contact-modal-confirm-btn"
            v-track="'primary-contact-modal-confirm-btn'"
          >
            CONFIRM
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { $invitations } from "@core/services";
import { mapGetters } from "vuex";
export default {
  name: "user-drawer",

  data() {
    return {
      account:[],
      accountId: "",
      loading: false,
      enableSaveAddUser: false,
      hasPrimaryContact: false,
      confirmSetPrimaryContactModal: false,
      invitationId: "",
      userAction: "",
      addNewUserEmail: "",
      disableUserEmail: false,
      validAddUserEmail: true,
      campaignsRadio: "",
      contentRadio: "",
      accountRadio: "",
      serviceTicketRadio: "",
      serviceContactRadio: "",
      reportRadio: "",
      titleReports: true,
      serviceContacts: true,
      serviceTickets: true,
      isPrimaryContact: false,
      s_access: false,
      m_access: false,
      roles: {
        campaigns: false,
        dns_setup: false,
        contacts: false,
        download_contacts: false,
        contents: false,
        surveys: false,
        reports: false,
        download_reports: false,
        automation: false,
        forms: false,
        relational_tables: false,
        ftp: false,
        mobile: false,
        push_notifications: false,
        coupon_codes: false,
        campaign_full_access: false,
        campaign_edit_schedule: false,
        campaign_requires_approval: false,
        bee_admin: false,
      },
      serviceRoles: {
        contacts_full_access: false,
        contacts_view_only: false,
        tickets_full_access: false,
        tickets_view_only: false,
        support_email: false,
      },
      generalRoles: {
        account: false,
        accounts_read_only: false,
      },
      primaryContact: false,
      emailRules: [
        (v) => !!v || "Email is required",
        (v) => !v || !!v.trim() || "Email cannot be blank",
        (v) =>
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "Invalid email.",
      ],
      activeTab: 0,
      toggle_marketing: true,
      toggle_service: true,
      tabList: [
        {
          id: "general",
          name: "General",
          value: "general",
          visible: true
        },
        {
          id: "marketing",
          name: "Marketing",
          value: "marketing",
          visible: false
        },
        {
          id: "service",
          name: "Service",
          value: "service",
          visible: false
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentAccount: "auth/account.current",
    }),
    hasPermissionSelected() {
      if(this.currentAccount.enable_service == true && this.currentAccount.enable_marketing == false){
          return this.toggle_service 
      } else if(this.currentAccount.enable_marketing == true && this.currentAccount.enable_service == false){
          return  this.toggle_marketing
      } else if( this.currentAccount.enable_marketing == true && this.currentAccount.enable_service == true)
          return this.toggle_service || this.toggle_marketing
    }
  },
  watch: {
    "generalRoles.account": function () {
      if (!this.generalRoles.account) {
        this.accountRadio = "";
      } else if (this.generalRoles.account && !this.accountRadio) {
        this.accountRadio = "account";
      }
    },
    "roles.contents": function () {
      if (!this.roles.contents) {
        this.contentRadio = "";
      } else if (this.roles.contents && !this.contentRadio) {
        this.contentRadio = "no";
      }
    },
    "roles.campaigns": function () {
      if (!this.roles.campaigns) {
        this.campaignsRadio = "";
      } else if (this.roles.campaigns && !this.campaignsRadio) {
        this.campaignsRadio = "campaign_full_access";
      }
    },
    titleReports: function () {
      if (!this.titleReports) {
        this.roles.reports = false;
        this.roles.download_reports = false;
      } else {
        this.roles.reports = true;
        this.roles.download_reports = true;
      }
    },
    serviceContacts: function () {
      if (!this.serviceContacts) {
        this.serviceContactRadio = "";
      } else if (this.serviceContacts && !this.serviceContactRadio) {
        this.serviceContactRadio = "contacts_full_access";
      }
    },
    serviceTickets: function () {
      if (!this.serviceTickets) {
        this.serviceTicketRadio = "";
      } else if (this.serviceTickets && !this.serviceTicketRadio) {
        this.serviceTicketRadio = "tickets_full_access";
      }
    },
    toggle_marketing(newVal) {
      const updatedValue = newVal ? true : false;
      for (const key in this.roles) {
        this.roles[key] = updatedValue;
      }
      this.titleReports = updatedValue;
    },
    toggle_service(newVal) {
      const updatedValue = newVal ? true : false;
      for (const key in this.serviceRoles) {
        this.serviceRoles[key] = updatedValue;
      }
      this.serviceContacts = updatedValue;
      this.serviceTickets = updatedValue;
    },
  },
  mounted() {
    this.account = this.$store.getters['auth/account.current'];
    if(this.account.enable_service){
      this.tabList[2].visible = true;
    }
    if(this.account.enable_marketing){
      this.tabList[1].visible = true;
    }
    if (this.$store.state.auth.editAccountId) {
      this.accountId = this.$store.state.auth.editAccountId;
    } else {
      this.accountId = this.$store.state.auth.account.id;
    }
    let drawerResponse = this.$store.state.ui.drawer.right.response;
    this.hasPrimaryContact = drawerResponse.hasPrimaryContact;
    this.invitationId = drawerResponse.invitationId;
    this.userAction = drawerResponse.userAction;
    this.isPrimaryContact = drawerResponse.isPrimary;
    if (this.userAction === "create") {
      let item = "";
      if(this.account.enable_marketing){
      for (item in this.roles) {
        this.roles[item] = true;
      }
      this.roles.campaign_full_access = true;
      this.roles.campaign_edit_schedule = false;
      this.roles.campaign_requires_approval = false;
      this.campaignsRadio = "campaign_full_access";
      this.roles.bee_admin = false;
      this.contentRadio = "no";
    }
      this.generalRoles.account = true;
      this.generalRoles.accounts_read_only = false;
      this.accountRadio = "account";
      if(this.account.enable_service){
        for (item in this.serviceRoles) {
        this.serviceRoles[item] = true;
        }
      this.serviceRoles.contacts_full_access = true;
      this.serviceRoles.contacts_view_only = false;
      this.serviceContactRadio = "contacts_full_access";
      this.serviceRoles.tickets_full_access = true;
      this.serviceRoles.tickets_view_only = false;
      this.serviceTicketRadio = "tickets_full_access";
      }
    } else if (this.userAction === "edit" || this.userAction === "duplicate") {
      this.loading = true;
      $invitations
        .show(this.invitationId)
        .then((response) => {
          if (this.userAction === "edit") {
            this.addNewUserEmail = response.data.data.invitation.email;
            this.disableUserEmail = true;
          }
          const responseRoles = response.data.data.invitation.roles;
          this.primaryContact = response.data.data.invitation.primary_contact;
          let i = 0;
          let element = "";
          for (i = 0; i < responseRoles.length; i++) {
            element = responseRoles[i];
            if (element.includes("service/")) {
              let ele = element.substring(8);
              this.serviceRoles[ele] = true;
              this.s_access = true;
            } 
            else if (element.includes("account" || "accounts_read_only")) {
              this.generalRoles[element] = true;
            } else {
              this.roles[element] = true;
              this.m_access = true;
            }
          }
          if (this.roles.campaign_full_access) {
            this.campaignsRadio = "campaign_full_access";
          } else if (this.roles.campaign_edit_schedule) {
            this.campaignsRadio = "campaign_edit_schedule";
          } else if (this.roles.campaign_requires_approval) {
            this.campaignsRadio = "campaign_requires_approval";
          }
          if (this.roles.contents && this.roles.bee_admin) {
            this.contentRadio = "yes";
          } else if (this.roles.contents && !this.roles.bee_admin) {
            this.contentRadio = "no";
          }
          if (this.generalRoles.accounts_read_only) {
            this.accountRadio = "accounts_read_only";
            this.generalRoles.account = true;
          } else if (this.generalRoles.account) {
            this.accountRadio = "account";
          }
          if (this.serviceRoles.tickets_full_access) {
            this.serviceTicketRadio = "tickets_full_access";
          } else if (this.serviceRoles.tickets_view_only) {
            this.serviceTicketRadio = "tickets_view_only";
          }
          if (this.serviceRoles.contacts_full_access) {
            this.serviceContactRadio = "contacts_full_access";
          } else if (this.serviceRoles.contacts_view_only) {
            this.serviceContactRadio = "contacts_view_only";
          }
          if (!this.roles.reports && !this.roles.download_reports) {
            this.titleReports = false;
          }
          if (this.roles.contacts && this.roles.download_contacts) {
            this.roles.download_contacts = true;
          } else {
            this.roles.download_contacts = false;
          }
          if (this.serviceContactRadio == "") {
            this.serviceContacts = false;
          }
          if (this.serviceTicketRadio == "") {
            this.serviceTickets = false;
          }
          if(!this.s_access){
            this.toggle_service = false
          }
          if(!this.m_access){
            this.toggle_marketing = false
          }
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  methods: {
    closeDrawer() {
      this.$store.commit("ui/drawer.right", {
        show: false,
        component: null,
        response: { checkUserUpdateInfo: true },
      });
    },
    checkHasPrimaryContact() {
      if (this.hasPrimaryContact === false && this.primaryContact) {
        this.setPrimaryContact();
      } else if (
        this.isPrimaryContact === true &&
        this.primaryContact === false
      ) {
        this.setPrimaryContact();
      } else {
        this.confirmSetPrimaryContactModal = true;
      }
    },
    setPrimaryContact() {
      this.loading = true;
      const payload = {
        invitation: {
          email: this.addNewUserEmail,
          primary_contact: this.primaryContact,
        },
      };
      $invitations
        .update(this.invitationId, payload)
        .then((response) => {
          this.$store.commit("ui/snackbar", {
            message: response.data.data.invitation.primary_contact
              ? "Successfully assigned primary user"
              : "Successfully unassigned primary user",
            type: "success",
          });
          this.closeDrawer();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveUserInfo() {
      if (!this.$refs.validAddUserEmail.validate()) return;
      this.loading = true;
      let payload = {
        invitation: {
          email: this.addNewUserEmail,
          roles: [],
        },
      };
      let item = "";
      let i = 0;
      for (item in this.roles) {
        if (
          item === "campaign_full_access" ||
          item === "campaign_edit_schedule" ||
          item === "campaign_requires_approval"
        ) {
          if (i === 0 && this.campaignsRadio) {
            payload.invitation.roles.push(this.campaignsRadio);
          }
          i++;
        } else if (item === "bee_admin") {
          if (this.contentRadio === "yes") {
            payload.invitation.roles.push(item);
          }
        } else {
          if (this.roles[item] === true) {
            payload.invitation.roles.push(item);
          }
        }
      }
      let service = "";
      let j = 0;
      for (service in this.serviceRoles) {
        if (
          service === "contacts_view_only" ||
          service === "contacts_full_access"
        ) {
          if (j === 0 && this.serviceContactRadio) {
            payload.invitation.roles.push(
              "service/" + this.serviceContactRadio
            );
          }
          j++;
        } else if (
          service === "tickets_view_only" ||
          service === "tickets_full_access"
        ) {
          if (j === 2 && this.serviceTicketRadio) {
            payload.invitation.roles.push("service/" + this.serviceTicketRadio);
          }
          j++;
        } else {
          if (this.serviceRoles[service] === true) {
            payload.invitation.roles.push("service/" + service);
          }
        }
      }
      for (item in this.generalRoles) {
        if (item === "accounts_read_only") {
          if (
            this.generalRoles.account &&
            this.accountRadio === "accounts_read_only"
          ) {
            payload.invitation.roles.push(item);
          }
        } else {
          if (this.generalRoles[item] === true) {
            payload.invitation.roles.push(item);
          }
        }
      }
      if (this.userAction === "create" || this.userAction === "duplicate") {
        $invitations
          .create(payload)
          .then((response) => {
            this.$store.commit("ui/snackbar", {
              message: response.data.message,
              type: "success",
            });
            this.closeDrawer();
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        payload.invitation.primary_contact = this.primaryContact;
        $invitations
          .update(this.invitationId, payload)
          .then((response) => {
            this.$store.commit("ui/snackbar", {
              message: "User updated successfully",
              type: "success",
            });
            this.closeDrawer();
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    toggleContact() {
      if (this.roles.contacts) {
        this.roles.download_contacts = true;
      } else {
        this.roles.download_contacts = false;
      }
    },
    reportToggle(){
        if(!this.roles.reports && !this.roles.download_reports)
        this.titleReports = false;
      }
  },
};
</script>
<style scoped>
.wrapper-row {
  margin: -12px !important;
}
</style>
